import CardGridContainer from './CardGridContainer';

export default CardGridContainer;
